(ns shared.core.config
  (:require [reagent.core :as ra]
            [clojure.string :as s]))

(def env-local "local")
(def env-dev "dev")
(def env-staging "staging")
(def env-prod "prod")

(def debug?* (ra/atom ^boolean goog.DEBUG))
(defn set-debug [v] (reset! debug?* v))

(def country-code* (ra/atom nil))
(defn set-country-code [v] (reset! country-code* v))

(goog-define GRAPHQL_HOST "localhost")
(goog-define GRAPHQL_PORT "9000")
(goog-define ADMIN_EMAIL "system@novolabs.com")
(goog-define VOX_CONSOLE_URL "https://console.vox.synq3-dev.com")
(goog-define PUTNAM_URL "https://putnam.synq3-dev.com")
(goog-define MENU_BOARD_URL "http://localhost:8082")
(goog-define GOOGLE_MAPS_API_KEY "AIzaSyCsaizZc6KXsUWetL2bE92Uvl-uqUxPyTo")
(goog-define DATADOG_RUM_APPLICATION_ID "")
(goog-define DATADOG_RUM_CLIENT_TOKEN "")
(goog-define DATADOG_CLIENT_TOKEN "")
(goog-define DATADOG_RUM_PROXY_PATH "")
(goog-define ENV "local")
(goog-define DD_ENV "local")
(goog-define VERSION "dev")
(goog-define NGROK_URL "")
(goog-define SERVER_URL "http://localhost:9000")
(goog-define VOX_ENDPOINT "wss://babel.synq3-staging.com/vox")
(goog-define SOSDK_API_KEY "")
(goog-define SOSDK_MENU_BOARD_BASE_URL "")
(goog-define SOSDK_VOX_WS_URL "")
(goog-define SOSDK_REALTIME_URL "")
(goog-define AUTH0_DOMAIN "")
(goog-define AUTH0_CLIENT_ID "")
(goog-define AUTH0_AUDIENCE "")
(goog-define AUTH0_SCOPE "")
(goog-define AUTH0_NAMESPACE "")

(defn local? []
  (#{"local" "LOCAL"} ENV))

(defn dev? []
  (#{"dev" "DEV"} ENV))

(defn staging? []
  (#{"staging" "STAGING"} ENV))

(defn prod? []
  (#{"prod" "PROD"} ENV))

(defn endpoint-url [path]
  (if (s/blank? NGROK_URL)
    (str "http"
         (when (= GRAPHQL_PORT "443") "s")
         "://" GRAPHQL_HOST ":" GRAPHQL_PORT path)
    NGROK_URL))

(defn server-url [path]
  (str SERVER_URL path))

(defn graphql-url []
  (if (s/blank? NGROK_URL)
    (if (= GRAPHQL_PORT "443")
      (str "https://" GRAPHQL_HOST ":" GRAPHQL_PORT "/graphql")
      (str "http://" GRAPHQL_HOST ":" GRAPHQL_PORT "/graphql"))
    (str NGROK_URL "/graphql")))

(defn custom-graphql-introspection-url []
  (if (s/blank? NGROK_URL)
    (if (= GRAPHQL_PORT "443")
      (str "https://" GRAPHQL_HOST ":" GRAPHQL_PORT "/custom-graphql-introspection")
      (str "http://" GRAPHQL_HOST ":" GRAPHQL_PORT "/custom-graphql-introspection"))
    (str NGROK_URL "/custom-graphql-introspection")))
